var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"apppnf"}},[_c('h1',{staticClass:"text-center",staticStyle:{"margin-top":"30px"}},[_vm._v("Ops! Pagina non trovata")])])}
var staticRenderFns = []

export { render, staticRenderFns }